module.exports = __webpack_public_path__ + "static/media/19.9e713f55.webp";